import styled from 'styled-components';
import { unthemed } from 'tokens';
import { ThumbnailSize } from './index';

const getDimension = (size?: ThumbnailSize) => {
	switch (size) {
		case ThumbnailSize.RIGHT_PANEL:
			return `${ThumbnailSize.RIGHT_PANEL}px`;
		case ThumbnailSize.MODAL:
			return `${ThumbnailSize.MODAL}px`;
		case ThumbnailSize.CHAT:
			return `${ThumbnailSize.CHAT}px`;
		default:
			return `${ThumbnailSize.RIGHT_PANEL}px`;
	}
};

interface BaseProps {
	size?: ThumbnailSize;
}
export const Base = styled.div<BaseProps>`
	position: relative;
	width: ${(props) => getDimension(props.size)};
	height: ${(props) => getDimension(props.size)};
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Icon = styled.div`
	position: absolute;
	// filter out mouse events on the icon, so that all clicks go to the base
	// otherwise Icon will block clicks on Base, and we won't detect when the user clicks the button
	pointer-events: none;
	top: -2px;
	right: -2px;
	pointer-events: all;
`;

interface ImageProps {
	size?: ThumbnailSize;
}
export const Image = styled.img<ImageProps>`
	// layout
	width: ${(props) => getDimension(props.size)};
	height: ${(props) => getDimension(props.size)};
	object-fit: cover;
	object-position: center;
	border-radius: 12px;
	border: 1px solid rgba(255, 255, 255, 0.25);
	// cursor: pointer;

	// on hover make the image a bit darker
	&:hover {
		filter: brightness(0.8);
	}
`;

interface LoadingProps {
	size?: ThumbnailSize;
}
// Dark background so the white moon reads. Matches the darkened overlay in
// FrameView so the two loading treatments feel like the same thing.
export const Loading = styled.div<LoadingProps>`
	width: ${(props) => getDimension(props.size)};
	height: ${(props) => getDimension(props.size)};
	object-fit: cover;
	object-position: center;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${unthemed.gray[900]};
`;

interface ErrorProps {
	size?: ThumbnailSize;
}
export const Error = styled.div<ErrorProps>`
	width: ${(props) => getDimension(props.size)};
	height: ${(props) => getDimension(props.size)};
	object-fit: cover;
	object-position: center;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${({ theme }) => theme.gray[100]};
`;
